function removeTagIds(tagCollection = [], tagIds) {
    return tagCollection.filter((id) => tagIds.indexOf(id) === -1);
}
export default removeTagIds;
//# sourceMappingURL=removeTagIds.js.map